import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';
import { DeliveryLine } from '../models/feed.model';

@Injectable({
  providedIn: 'root',
})
export class FeedService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/dairy-delivery/secure/delivery-line';

  public get(dateFrom: string, dateTo: string): Observable<DeliveryLine[]> {
    return this.http.get<DeliveryLine[]>(`${this.baseUrl}?dateFrom=${dateFrom}&dateTo=${dateTo}`);
  }
}
